import log from 'salvo-lite/log'
import AOS from 'aos'
import 'aos/dist/aos.css'

class InitAOS {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._options = {
            forceSections: false,
            animation: null,
            ...JSON.parse(elem.getAttribute('data-init-aos') || '{}')
        }

        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        const { _options } = this
        const { forceSections, animation } = _options

        if (forceSections) {
            console.log(_options)
            window.onload = function () {
                const sections = document.querySelectorAll('section')

                for (let i = 0; i < sections.length; i++) {
                    sections[i].setAttribute('data-aos', animation)
                }

                AOS.init()
            }
        } else {
            AOS.init()
        }
    }
}

export default InitAOS



// WEBPACK FOOTER //
// ./src/resources/scripts/components/InitAOS.js